import * as types from './types';

export const setActiveMetric = (i, fieldName) => ({ type: types.SET_ACTIVE_METRIC, i, fieldName });

export const setInactiveMetrics = (inactiveMetrics, defaultActiveMetrics) => ({
  type: types.SET_INACTIVE_METRICS,
  inactiveMetrics,
  defaultActiveMetrics
});
